import React, { useState } from 'react';
import { FaEnvelope, FaMapMarkerAlt, FaGithub, FaLinkedin, FaCopy, FaArrowRight } from 'react-icons/fa';
import { contactData } from '../data/contact';
import './Contact.css';

const Contact = () => {
  const data = contactData;
  const [emailCopied, setEmailCopied] = useState(false);

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(data.email);
      setEmailCopied(true);
      setTimeout(() => setEmailCopied(false), 2000);
    } catch (_) {}
  };

  return (
    <section id="contact" className="contact-section">
      <div className="section-heading fade-in-up">
        <h2>{data.heading}</h2>
        <p>{data.description}</p>
      </div>

      <div className="contact-container fade-in-up">
        <div className="contact-card">

          {/* ── Left gradient panel ── */}
          <div className="contact-left">
            <p className="contact-left-title">Let's work together on something great.</p>
            <p className="contact-left-desc">
              Open to full-time roles, contract work, and interesting DevOps or AI infrastructure projects. Drop me a message — I respond within 24 hours.
            </p>

            <div className="contact-left-items">
              <div className="contact-left-item">
                <div className="contact-left-item-icon"><FaEnvelope /></div>
                <div className="contact-left-item-text">
                  <span className="contact-left-item-label">Email</span>
                  <a href={`mailto:${data.email}`} className="contact-left-item-value">{data.email}</a>
                </div>
              </div>
              <div className="contact-left-item">
                <div className="contact-left-item-icon"><FaMapMarkerAlt /></div>
                <div className="contact-left-item-text">
                  <span className="contact-left-item-label">Location</span>
                  <span className="contact-left-item-value">{data.location}</span>
                </div>
              </div>
            </div>
          </div>

          {/* ── Right actions panel ── */}
          <div className="contact-right">
            <p className="contact-right-title">Get in touch</p>

            <div className="contact-cta-group">
              {/* Email with copy */}
              <div className="contact-cta-btn" style={{ cursor: 'default' }}>
                <div className="contact-cta-icon"><FaEnvelope /></div>
                <div className="contact-cta-text">
                  <span className="contact-cta-label">Send an email</span>
                  <span className="contact-cta-value">{data.email}</span>
                </div>
                <button className="email-copy-trigger" onClick={copyEmail} title="Copy">
                  <FaCopy />
                  {emailCopied ? 'Copied!' : 'Copy'}
                  {emailCopied && <span className="copied-text">Copied!</span>}
                </button>
              </div>

              {/* LinkedIn */}
              {data.social?.linkedin && (
                <a href={data.social.linkedin} target="_blank" rel="noopener noreferrer" className="contact-cta-btn">
                  <div className="contact-cta-icon"><FaLinkedin /></div>
                  <div className="contact-cta-text">
                    <span className="contact-cta-label">Connect on</span>
                    <span className="contact-cta-value">LinkedIn</span>
                  </div>
                  <FaArrowRight className="contact-cta-arrow" />
                </a>
              )}

              {/* GitHub */}
              {data.social?.github && (
                <a href={data.social.github} target="_blank" rel="noopener noreferrer" className="contact-cta-btn">
                  <div className="contact-cta-icon"><FaGithub /></div>
                  <div className="contact-cta-text">
                    <span className="contact-cta-label">See my work on</span>
                    <span className="contact-cta-value">GitHub</span>
                  </div>
                  <FaArrowRight className="contact-cta-arrow" />
                </a>
              )}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Contact;
